/* Реестр долгосрочных лицензий */
const RegisterLongTermLicenses = () =>
  import(/* webpackChunkName: "Catalogs" */ 'RootDir/modules/LegalEntities/RegisterLongTermLicenses.vue');

export default [
  {
    path: 'register-long-term-licenses',
    name: 'legal-entities-register-long-term-licenses',
    component: RegisterLongTermLicenses,
  },
];
